import axiosCli from "../vue/axios/axios";


async function getCompanies(params, headers) {
    return await axiosCli.get('/company_monitorings/get_user_monitored_companies', {
        params: params,
        headers: headers
    });
}


export default {
    getCompanies,
}